import(/* webpackMode: "eager" */ "/home/runner/work/mdsite4/mdsite4/app/landing.css");
;
import(/* webpackMode: "eager", webpackExports: ["HardwareIndex"] */ "/home/runner/work/mdsite4/mdsite4/components/photon/hardware-page.tsx");
